<template>

  <GroupReservationHead :reservation="order.reservation" :selectedGroup="order.selectedGroup" :order="order" />

  <div class="mx-auto bg-white mt-10">
    <form method="post" @submit.prevent="handleSubmit" ref="registerForm">
      <fieldset>
        <div class="text-lg font-semibold leading-relaxed mb-4">Dane uczestnika</div>


        <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">


          <FormInput class="sm:col-span-3" label="Imię" v-model="form.first_name" placeholder="" name="first_name"
            id="first_name" autocomplete="given-name" :error="errors.first_name" />

          <FormInput class="sm:col-span-3" label="Nazwisko" v-model="form.last_name" placeholder="" name="last_name"
            id="last_name" autocomplete="family-name" :error="errors.last_name" />

          <FormInput class="sm:col-span-6" label="Email" v-model="form.email" type="email" :disabled="isEmailReadonly"
            @blur="checkEmail" name="email" id="email" autocomplete="email" :error="errors.email" />


          <div v-if="showResetEmailButton" class="sm:col-span-6">
            <button @click="resetLogin"
              class="w-full sm:w-1/2 inline-flex justify-center whitespace-nowrap bg-primary-500 px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 hover:bg-secondaary-600 focus:outline-none focus:ring focus:ring-primary-300 focus-visible:outline-none focus-visible:ring focus-visible:ring-secondary-300 transition-colors duration-150">Zaloguj
              się na {{ this.loginEmail }} </button>
          </div>

          <FormInput class="sm:col-span-6" label="Telefon" v-model="form.phone" :disabled="isPhoneDisabled"
            placeholder="+48 000 000 000" name="phone" id="phone" autocomplete="tel" @blur="checkPhone"
            :error="errors.phone" />

          <div v-if="showResetPhoneButton" class="sm:col-span-6">
            <button @click="resetLogin"
              class="w-full sm:w-1/2 inline-flex inline-flex justify-center whitespace-nowrap bg-primary-500 px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 hover:bg-secondaary-600 focus:outline-none focus:ring focus:ring-primary-300 focus-visible:outline-none focus-visible:ring focus-visible:ring-secondary-300 transition-colors duration-150">Zaloguj
              się na {{ this.loginPhone }} </button>
          </div>

          <FormInput class="col-span-full" label="Adres" v-model="form.address" placeholder="ul. Przykładowa 1/2"
            name="address" id="address" autocomplete="street-address" :error="errors.address" />

          <FormInput class="sm:col-span-4" label="Miasto" v-model="form.city" placeholder="Warszawa" name="city"
            id="city" autocomplete="address-level4" :error="errors.city" />

          <FormInput class="sm:col-span-2" label="Kod pocztowy" v-model="form.postalcode" placeholder="00-001"
            name="postalcode" id="postalcode" autocomplete="postal-code" :error="errors.postalcode"
            @blur="validateIfError" />


        </div>
      </fieldset>

      <FormSection v-if="profile" class="mt-10 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6" title="Dodatkowe informacje o uczestniku">
        <!-- Take profile and generate dropdown -->
        <!-- Dynamically generate dropdowns based on the structure -->
        <div v-for="(options, title) in profile" :key="slug(title)" class="sm:col-span-3">
          <label :for="slug(title)" class="block text-sm/6 font-medium text-gray-900">{{
            title
          }}</label>
          <div class="mt-2">
            <select v-model="form.profile[title]" :name="slug(title)" :id="slug(title)"
              :class="`mt-1 block w-full border-gray-300 shadow-sm sm:text-sm focus:border-secondary-400 focus:ring-2 focus:ring-primary-500 ${roundedClass} ${errors[slug(title)] ? 'border-red-500' : ''}`">
              <option value="" selected>Wybierz</option>
              <option v-for="option in options" :key="option" :value="option">{{ option }}</option>
            </select>
            <p v-if="errors[slug(title)]" class="text-red-500 text-sm mt-1">{{ errors[slug(title)]
            }}
            </p>
          </div>
        </div>
      </FormSection>

      <div class="mt-6 flex items-start gap-3 p-4 -mx-4 rounded-lg">
        <div class="mt-0.5">
          <ToggleSwitch v-model="form.needs_company" />
        </div>
        <label class="flex-1 cursor-pointer" @click="form.needs_company = !form.needs_company">
          <div class="text-sm font-semibold text-neutral-850 block mb-1">
            Zaznacz aby otrzymać fakturę
          </div>
          <div class="text-xs text-neutral-600">Zaznacz, jeśli kupujesz jako firma i potrzebujesz faktury.</div>
        </label>
      </div>



      <FormSection class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6" title="Dane do faktury"
        v-if="form.needs_company">


        <FormInput class="sm:col-span-6" label="Firma" v-model="form.company_name" placeholder="" name="company_name"
          id="company_name" autocomplete="organization" :error="errors.company_name" />

        <FormInput class="sm:col-span-3" label="NIP" v-model="form.company_tax" placeholder="123-456-32-18"
          name="company_tax" id="company_tax" autocomplete="NIP" :error="errors.company_tax" />


        <FormInput class="col-span-full" label="Adres siedziby firmy" v-model="form.company_address"
          placeholder="ul. Firmowa 1/2" name="company_address" id="company_address" autocomplete="street-address"
          :error="errors.company_address" />

        <FormInput class="sm:col-span-4" label="Miasto" v-model="form.company_city" placeholder="Warszawa"
          name="company_city" id="company_city" autocomplete="address-level4" :error="errors.company_city" />


        <FormInput class="sm:col-span-2" label="Kod pocztowy" v-model="form.company_postalcode" placeholder="00-001"
          name="company_postalcode" id="company_postalcode" autocomplete="postal-code"
          :error="errors.company_postalcode" />



      </FormSection>

      <NextButton v-if="order" :onNext="handleSubmit" :onPrev="onCancel" />
    </form>

    <Summary :order="order" class="lg:hidden" />

  </div>
</template>

<script>
import Globals from '@shared/model/Globals.js';
import rpAPI from '@shared/service/rpAPI.js';
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue';

import NextButton from './NextButton.vue';
import Summary from './Summary.vue';
import { format } from 'date-fns';
import GroupReservationHead from './GroupReservationHead.vue';

import PageHeader from './PageHeader.vue';
import FormSection from './FormSection.vue';
import ToggleSwitch from './ToggleSwitch.vue';
import FormInput from './FormInput.vue';



export default {
  name: 'Register',
  components: {

    rpAPI,
    NextButton,
    Summary,
    GroupReservationHead,
    ToggleSwitch,
    FormInput,
    FormSection
  },
  props: {
    onNext: {
      type: Function,
      default: () => () => { }
    },
    onCancel: {
      type: Function,
      default: () => () => { }
    },

    order: {
      type: Object,
      default: () => ({})
    },

    settings: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      profile: this.order.reservation?.profile,
      form: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        city: '',
        address: '',
        postalcode: '',
        second_caretaker: true,
        second_caretaker_name: '',
        second_caretaker_phone: '',
        needs_company: false,
        company_name: '',
        company_address: '',
        company_city: '',
        company_postalcode: '',
        company_tax: '',
        profile: this.buildProfile(this.order.reservation?.profile ?? {})
      },
      errors: {},
      hasEmailChecked: false,
      hasPhoneChecked: false,
      showResetEmailButton: false,
      showResetPhoneButton: false,
      loginPhone: '',
      loginEmail: ''
    };
  },
  created() {
    if (this.user) {
      this.form.first_name = rpAPI.capitalizePhrase(this.user.first_name) || '';
      this.form.last_name = rpAPI.capitalizePhrase(this.user.last_name) || '';
      this.form.city = rpAPI.capitalizePhrase(this.user.city) || '';
      this.form.address = rpAPI.capitalizePhrase(this.user.address) || '';
      this.form.company_city = rpAPI.capitalizePhrase(this.user.company_city) || '';
      this.form.second_caretaker_name = rpAPI.capitalizePhrase(this.user.second_caretaker_name) || '';
      const domain = '@' + Globals.EMAIL_DOMAIN;
      if (this.user.email == this.user.phone + domain) {
        this.form.email = '';
      } else {
        this.form.email = this.user.email || '';
      }
      this.form.phone = this.user.phone || '';
      this.form.postalcode = this.user.postalcode || '';
      this.form.needs_company = this.user.needs_company || false;
      this.form.company_name = this.user.company_name || '';
      this.form.company_address = this.user.company_address || '';
      this.form.company_postalcode = this.user.company_postalcode || '';
      this.form.company_tax = this.user.company_tax || '';
      this.form.company_city = this.user.company_city || '';
      this.form.second_caretaker = this.user.second_caretaker == null ? false : this.user.second_caretaker;
      this.form.second_caretaker_phone = this.user.second_caretaker_phone || '';
      this.form.second_caretaker_name = this.user.second_caretaker_name || '';


    }
  },
  computed: {
    user() {
      return rpAPI.user;
    },
    enabled_second_caretaker() {
      return this.form.second_caretaker;
    },
    enabled_company() {
      return this.form.needs_company;
    },
    isEmailReadonly() {
      return rpAPI.useEmailAuth;
    },
    isPhoneDisabled() {
      return rpAPI.usePhoneAuth;
    },
    roundedClass() {
      return Globals.getRoundedClass();
    }
  },

  methods: {

    slug(text) {
      // Zamiana polskich znaków na ich odpowiedniki
      const polishMap = {
        'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
        'Ą': 'a', 'Ć': 'c', 'Ę': 'e', 'Ł': 'l', 'Ń': 'n', 'Ó': 'o', 'Ś': 's', 'Ź': 'z', 'Ż': 'z'
      };
      text = text.replace(/[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g, match => polishMap[match]);
      text = text.trim().replace(/\s+/g, '-');
      text = text.replace(/[^a-zA-Z0-9-]/g, '');
      return text.toLowerCase();
    },

    buildProfile(profile) {
      return Object.keys(profile).reduce((acc, key) => {
        acc[key] = "";
        return acc;
      }, {});
    },
    formatPhone(phone) {
      if (!phone) return '';
      // Format phone number to +48 123 456 789
      const sanitizedPhone = phone.replace(/\D/g, ''); // Remove non-digit characters
      if (sanitizedPhone.length === 9) {
        return `+48 ${sanitizedPhone.slice(0, 3)} ${sanitizedPhone.slice(3, 6)} ${sanitizedPhone.slice(6)}`;
      } else if (sanitizedPhone.length > 9) {
        return `+${sanitizedPhone.slice(0, sanitizedPhone.length - 9)} ${sanitizedPhone.slice(-9, -6)} ${sanitizedPhone.slice(-6, -3)} ${sanitizedPhone.slice(-3)}`;
      }
      return phone;
    },
    maskEmailAdress(email) {
      return email.replace(/^(.)(.*)(@.*)$/, (_, a, b, c) => a + b.replace(/./g, '*') + c);
    },
    async resetLogin() {
      await rpAPI.logout();
      if (this.onCancel) {
        this.onCancel();
      }
      console.log('Reset login');
    },

    async checkEmail() {
      if (this.isEmailReadonly || (this.user?.email && this.form.email === this.user.email)) {
        this.errors.email = '';
        this.hasEmailChecked = true;
        this.showResetEmailButton = false;
        return false;
      }
      if (this.form.email) {
        const res = await rpAPI.checkIfEmailExist(this.form.email, this.user?.id);
        if (res) {
          this.loginEmail = this.form.email;
          this.errors.email = 'Istnieje już konto w systemie z podanym adresem email. Jeśli to Twoje konto cofnij się na poprzednią stronę i zaloguj się na podany adres email. Jeśli to nie Twój email, podaj inny adres email.';
          this.showResetEmailButton = true;
          // we need to check email again 
          this.hasEmailChecked = false;
          return true;
        } else {
          this.errors.email = '';
          this.hasEmailChecked = true;
          this.showResetEmailButton = false;
          return false;
        }
      }
    },



    validatePhoneIfError() {
      if (this.errors.phone !== '') {
        this.checkPhone();
      }
    },

    async checkPhone() {
      if (this.form.phone.length === 9) {
        this.form.phone = '+48' + this.form.phone;
      } else {
        this.form.phone = this.form.phone.startsWith('+') ? this.form.phone : '+' + this.form.phone;
      }
      if (this.isPhoneDisabled || (this.user?.phone && this.form.phone === this.user.phone)) {
        this.errors.phone = '';
        this.hasPhoneChecked = true;
        this.showResetPhoneButton = false;
        return false;
      }
      if (this.form.phone) {
        const res = await rpAPI.checkIfPhoneExist(this.form.phone, this.user?.id);
        if (res) {
          this.loginPhone = this.maskEmailAdress(this.form.phone);
          this.errors.phone = 'Istnieje już konto z podanym numerem telefonu. Jeśli to Twój telefon cofnij się na poprzednią stronę i zaloguj się używając telefonu. Jeśli to nie Twój telefon, podaj inny numer telefonu.';
          this.showResetPhoneButton = true;
          // we need to check email again 
          this.hasPhoneChecked = false;
          return true;
        } else {
          this.errors.phone = '';
          this.hasPhoneChecked = true;
          this.showResetPhoneButton = false;
          return false;
        }
      }
    },


    filterAgreements(agreementId) {
      const agreement = agreementId.Agreements_id;
      if (!agreement.condition || agreement.condition === '') {
        return true;
      }
      if (agreement.condition === 'insurance') {
        if (this.order.insurance.price <= 0)
          return false;
        else
          return true;
      }
      return true;
    },


    validateIfError(event) {
      const fieldName = event.target.name || event.target.id;
      if (this.errors[fieldName] && this.errors[fieldName] != '') {
        this.validateForm(false);
      }
    },

    validateForm(scrollToError = true) {

      if (this.showResetEmailButton || this.showResetPhoneButton) {
        return false;
      }
      this.errors = {};
      this.form.first_name = rpAPI.capitalizePhrase(this.form.first_name);
      this.form.last_name = rpAPI.capitalizePhrase(this.form.last_name);
      this.form.city = rpAPI.capitalizePhrase(this.form.city);
      this.form.company_city = rpAPI.capitalizePhrase(this.form.company_city);
      this.form.address = rpAPI.capitalizePhrase(this.form.address);
      this.form.company_address = rpAPI.capitalizePhrase(this.form.company_address);
      this.form.postalcode = this.form.postalcode.replace(/\s+/g, ''); // Remove spaces from postal code
      this.form.company_postalcode = this.form.company_postalcode.replace(/\s+/g, ''); // Remove spaces from company postal code

      // Validate postal code: allow "12-345" or "12345"
      const postalCodePattern = /^(\d{2}-\d{3}|\d{5})$/;
      if (this.form.postalcode && !postalCodePattern.test(this.form.postalcode)) {
        this.errors.postalcode = 'Proszę wpisać poprawny kod pocztowy (np. 12-345 lub 12345)';
      }

      this.form.second_caretaker_name = rpAPI.capitalizePhrase(this.form.second_caretaker_name);
      this.form.second_caretaker_phone = this.formatPhone(this.form.second_caretaker_phone.replace(/\s+/g, '')); // Remove spaces from second caretaker phone

      // Validate required fields
      if (!this.form.first_name) this.errors.first_name = 'Proszę wpisać imię';
      if (!this.form.last_name) this.errors.last_name = 'Proszę wpisać nazwisko';



      // Validate email
      if (!this.form.email) {
        this.errors.email = 'Proszę wpisać email';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
        this.errors.email = 'Proszę wpisać poprawny email';
      }


      if (!this.form.phone) {
        this.errors.phone = 'Proszę wpisać numer telefonu';
      } else {
        const sanitizedPhone = this.form.phone.replace(/\s+/g, '');
        if (!/(\+?\d{1,3})?(\d{3})(\d{3})(\d{3})/.test(sanitizedPhone)) {
          this.errors.phone = 'Proszę wpisać poprawny numer telefonu z prefixem krajowym np. +48 123 456 789';
        } else {
          this.form.phone = sanitizedPhone; // Remove spaces and update the phone number
        }
      }

      if (!this.form.city) this.errors.city = 'Proszę wpisać miasto';
      if (!this.form.postalcode) this.errors.postalcode = 'Proszę wpisać kod pocztowy';
      if (!this.form.address) this.errors.address = 'Proszę wpisać adres';

      // Dynamic profile fields are required at registration stage.
      if (this.profile && typeof this.profile === 'object') {
        Object.keys(this.profile).forEach((title) => {
          const fieldKey = this.slug(title);
          const fieldValue = this.form.profile?.[title];
          if (!fieldValue) {
            this.errors[fieldKey] = 'Proszę wybrać opcję';
          }
        });
      }

      if (this.form.second_caretaker && !this.form.second_caretaker_name) {
        this.errors.second_caretaker_name = 'Proszę wpisać imię i nazwisko drugiego opiekuna';
      }
      if (this.form.second_caretaker && !this.form.second_caretaker_phone) {
        this.errors.second_caretaker_phone = 'Proszę wpisać numer telefonu drugiego opiekuna';
      } else if (this.form.second_caretaker_phone) {
        const sanitizedSecondCaretakerPhone = this.form.second_caretaker_phone.replace(/\s+/g, '');
        if (!/(\+?\d{1,3})?(\d{3})(\d{3})(\d{3})/.test(sanitizedSecondCaretakerPhone)) {
          this.errors.second_caretaker_phone = 'Proszę wpisać poprawny numer telefonu drugiego opiekuna z prefixem krajowym np. +48 123 456 789';
        } else {
          this.form.second_caretaker_phone = sanitizedSecondCaretakerPhone; // Remove spaces and update the phone number
        }
      }

      // Validate company fields if needed
      if (this.form.needs_company) {
        if (!this.form.company_name) this.errors.company_name = 'Proszę wpisać nazwę firmy';
        if (!this.form.company_tax) {
          this.errors.company_tax = 'Proszę wpisać NIP';
        } else if (!/^\d{10}$/.test(this.form.company_tax)) {
          this.errors.company_tax = 'Proszę wpisać poprawny numer NIP';
        }
        if (!this.form.company_city) this.errors.company_city = 'Proszę wpisać miasto w danych firmy';
        if (!this.form.company_postalcode) this.errors.company_postalcode = 'Proszę wpisać kod pocztowy w danych firmy';
        if (!this.form.company_address) this.errors.company_address = 'Proszę wpisać adres w danych firmy';

        if (this.form.company_postalcode && !postalCodePattern.test(this.form.company_postalcode)) {
           this.errors.company_postalcode = 'Proszę wpisać poprawny kod pocztowy w danych firmy (np. 12-345 lub 12345)';
        }
      }
      let vA = false || (!this.$refs.agreementSelector);
      if (this.$refs.agreementSelector) {
        vA = this.$refs.agreementSelector.validateAgreements();
      }

      //   // if email hasn't been checked yet, check it 
      //   if ((!this.hasEmailChecked || !this.hasPhoneChecked) ) {
      //     // this.errors.email = 'Sprawdzam email...';
      //     // this.errors.phone = 'Sprawdzam telefon...';
      //     // this.checkEmail();
      //     // this.checkPhone();
      //     return false;
      // }

      if (Object.keys(this.errors).length > 0) {

        // Scroll to first input with error
        if (scrollToError) {
          this.$nextTick(() => {
            const firstErrorField = Object.keys(this.errors)[0];
            if (firstErrorField) {
              const element = document.getElementById(firstErrorField) ||
                document.querySelector(`[name="${firstErrorField}"]`);
              if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                element.focus();
              }
            }
          });
        }

        return false;
      }

      return Object.keys(this.errors).length === 0 && vA;
    },

    triggerSubmit() {

    },

    async handleSubmit() {

      if (!this.hasEmailChecked || !this.hasPhoneChecked) {
        // const checkInterval = setInterval(() => {
        //   if ((this.hasEmailChecked && this.hasPhoneChecked) || Object.keys(this.errors).length == 0) {
        //     clearInterval(checkInterval);
        //     this.handleSubmit();
        //   }
        // }, 400);
        await this.checkEmail();
        await this.checkPhone();
      }


      try {
        if (!this.validateForm()) return false;

        let formCopy = JSON.parse(JSON.stringify(this.form));

        let customer = rpAPI.user;
        await customer.initProfiles();

           
        // AKA, we don't use profiles, every registered user is participiant
        // When there is not participiants we need to create one

        let defaultProfile = customer.defaultProfile();
        if (!defaultProfile) {
            defaultProfile = {
                first_name: formCopy.first_name || "",
                last_name: formCopy.last_name || "",
                profile: formCopy.profile || {}
            };
            
        } else {
          defaultProfile.first_name = formCopy.first_name || defaultProfile.first_name || "";
          defaultProfile.last_name = formCopy.last_name || defaultProfile.last_name || "";
          defaultProfile.profile = formCopy.profile || defaultProfile.profile || {};
        }
        // RLO, sprawdź czy profile się zapisały, jeśli nie, to dodaj je do formCopy, żeby rpAPI.updateCustomer je zapisał
        delete formCopy.profile; // usuwamy profile z formCopy, bo już je zaktualizowaliśmy w defaultProfile
       
        await customer.updateProfiles([defaultProfile]);
        await rpAPI.updateCustomer(formCopy);
        customer = rpAPI.user;
        await customer.initProfiles();
        this.order.setCustomer(customer);
        this.order.setParticipants([customer.defaultProfile()]);


        if (this.onNext)
          this.onNext();

        return true;
      }
      catch (error) {
        alert(error.message);
        return false;
      }

    }
  },
  mounted() {
    // Override the form's checkValidity method with custom validation logic
    this.$refs.registerForm.checkValidity = this.validateForm;
  }
};
</script>
